import Showcase from "../../components/Showcase";
import { useNavigate } from "react-router-dom";
export default function OnboardGettingStarted() {
  const navigate = useNavigate();

return (
      <div
        className="min-h-[calc(100vh-60px)] bg-cover bg-center flex flex-col text-center font-sans bg-white"
      >
        <div className="max-w-md mx-auto px-4 py-6 space-y-2">
          <section className="p-4 rounded-xl">
            <Showcase/>
          </section>
      </div>
    </div>
);
}